import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'star-rater',
  templateUrl: './star-rater.component.html',
  styleUrls: ['./star-rater.component.css']
})
export class StarRaterComponent {
  displayText:any = 'ss';
  public disabled!: boolean;
  public ratingText!: string;
  @Input() public _value: number = 0;
  public ratings = [
    {
      stars: 1,
      text: '1'
    },
    {
      stars: 2,
      text: 'm2eh'
    },
    {
      stars: 3,
      text: '3'
    },
    {
      stars: 4,
      text: '4'
    },
    {
      stars: 5,
      text: '5'
    }
  ]
  onChanged: any = () => {}
  onTouched: any = () => {}
  @Output() selectedStar: EventEmitter<number> = new EventEmitter<number>();
  writeValue(val:any) {
    this._value = val;
  }
  registerOnChange(fn: any){
    this.onChanged = fn
  }
  registerOnTouched(fn: any){
    this.onTouched = fn
  }
  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
  setRating(star: any) {
    if(!this.disabled) {
      this._value = star.stars;
      // this.ratingText = star.text;
      this.selectedStar.emit(star.stars);
      this.onChanged(star.stars);
      this.onTouched();
    }
  }
}
